(function() {
  const modal = document.getElementById('notify-me-modal');
  if (!modal) return;

  /**
   * Returns SHA-256 hex digest of a string (async, uses Web Crypto API).
   * @param {string} str - Input string (e.g. normalized email).
   * @returns {Promise<string>} Hex-encoded SHA-256 hash.
   */
  function sha256Hex(str) {
    const buf = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-256', buf).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map((b) => ('0' + b.toString(16)).slice(-2)).join('');
    });
  }

  /**
   * Returns MD5 hex digest of a string (sync, minimal implementation).
   * @param {string} str - Input string (e.g. normalized email).
   * @returns {string} Hex-encoded MD5 hash.
   */
  function md5Hex(str) {
    function md5cycle(x, k) {
      let a = x[0], b = x[1], c = x[2], d = x[3];
      a = ff(a, b, c, d, k[0], 7, -680876936);
      d = ff(d, a, b, c, k[1], 12, -389564586);
      c = ff(c, d, a, b, k[2], 17, 606105819);
      b = ff(b, c, d, a, k[3], 22, -1044525330);
      a = ff(a, b, c, d, k[4], 7, -176418897);
      d = ff(d, a, b, c, k[5], 12, 1200080426);
      c = ff(c, d, a, b, k[6], 17, -1473231341);
      b = ff(b, c, d, a, k[7], 22, -45705983);
      a = ff(a, b, c, d, k[8], 7, 1770035416);
      d = ff(d, a, b, c, k[9], 12, -1958414417);
      c = ff(c, d, a, b, k[10], 17, -42063);
      b = ff(b, c, d, a, k[11], 22, -1990404162);
      a = ff(a, b, c, d, k[12], 7, 1804603682);
      d = ff(d, a, b, c, k[13], 12, -40341101);
      c = ff(c, d, a, b, k[14], 17, -1502002290);
      b = ff(b, c, d, a, k[15], 22, 1236535329);
      a = gg(a, b, c, d, k[1], 5, -165796510);
      d = gg(d, a, b, c, k[6], 9, -1069501632);
      c = gg(c, d, a, b, k[11], 14, 643717713);
      b = gg(b, c, d, a, k[0], 20, -373897302);
      a = gg(a, b, c, d, k[5], 5, -701558691);
      d = gg(d, a, b, c, k[10], 9, 38016083);
      c = gg(c, d, a, b, k[15], 14, -660478335);
      b = gg(b, c, d, a, k[4], 20, -405537848);
      a = gg(a, b, c, d, k[9], 5, 568446438);
      d = gg(d, a, b, c, k[14], 9, -1019803690);
      c = gg(c, d, a, b, k[3], 14, -187363961);
      b = gg(b, c, d, a, k[8], 20, 1163531501);
      a = gg(a, b, c, d, k[13], 5, -1444681467);
      d = gg(d, a, b, c, k[2], 9, -51403784);
      c = gg(c, d, a, b, k[7], 14, 1735328473);
      b = gg(b, c, d, a, k[12], 20, -1926607734);
      a = hh(a, b, c, d, k[5], 4, -378558);
      d = hh(d, a, b, c, k[8], 11, -2022574463);
      c = hh(c, d, a, b, k[11], 16, 1839030562);
      b = hh(b, c, d, a, k[14], 23, -35309556);
      a = hh(a, b, c, d, k[1], 4, -1530992060);
      d = hh(d, a, b, c, k[4], 11, 1272893353);
      c = hh(c, d, a, b, k[7], 16, -155497632);
      b = hh(b, c, d, a, k[10], 23, -1094730640);
      a = hh(a, b, c, d, k[13], 4, 681279174);
      d = hh(d, a, b, c, k[0], 11, -358537222);
      c = hh(c, d, a, b, k[3], 16, -722521979);
      b = hh(b, c, d, a, k[6], 23, 76029189);
      a = hh(a, b, c, d, k[9], 4, -640364487);
      d = hh(d, a, b, c, k[12], 11, -421815835);
      c = hh(c, d, a, b, k[15], 16, 530742520);
      b = hh(b, c, d, a, k[2], 23, -995338651);
      a = ii(a, b, c, d, k[0], 6, -198630844);
      d = ii(d, a, b, c, k[7], 10, 1126891415);
      c = ii(c, d, a, b, k[14], 15, -1416354905);
      b = ii(b, c, d, a, k[5], 21, -57434055);
      a = ii(a, b, c, d, k[12], 6, 1700485571);
      d = ii(d, a, b, c, k[3], 10, -1894986606);
      c = ii(c, d, a, b, k[10], 15, -1051523);
      b = ii(b, c, d, a, k[1], 21, -2054922799);
      a = ii(a, b, c, d, k[8], 6, 1873313359);
      d = ii(d, a, b, c, k[15], 10, -30611744);
      c = ii(c, d, a, b, k[6], 15, -1560198380);
      b = ii(b, c, d, a, k[13], 21, 1309151649);
      a = ii(a, b, c, d, k[4], 6, -145523070);
      d = ii(d, a, b, c, k[11], 10, -1120210379);
      c = ii(c, d, a, b, k[2], 15, 718787259);
      b = ii(b, c, d, a, k[9], 21, -343485551);
      x[0] = (a + x[0]) | 0;
      x[1] = (b + x[1]) | 0;
      x[2] = (c + x[2]) | 0;
      x[3] = (d + x[3]) | 0;
    }
    function cmn(q, a, b, x, s, t) {
      a = (((a + q) | 0) + ((x + t) | 0)) | 0;
      return (((a << s) | (a >>> (32 - s))) + b) | 0;
    }
    function ff(a, b, c, d, x, s, t) { return cmn((b & c) | ((~b) & d), a, b, x, s, t); }
    function gg(a, b, c, d, x, s, t) { return cmn((b & d) | (c & (~d)), a, b, x, s, t); }
    function hh(a, b, c, d, x, s, t) { return cmn(b ^ c ^ d, a, b, x, s, t); }
    function ii(a, b, c, d, x, s, t) { return cmn(c ^ (b | (~d)), a, b, x, s, t); }
    function md5blk(s) {
      const md5blks = [];
      for (let i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    }
    const n = str.length;
    const state = [1732584193, -271733879, -1732584194, 271733878];
    let i;
    for (i = 64; i <= str.length; i += 64) {
      md5cycle(state, md5blk(str.substring(i - 64, i)));
    }
    str = str.substring(i - 64);
    const tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (i = 0; i < str.length; i++) tail[i >> 2] |= str.charCodeAt(i) << ((i % 4) << 3);
    tail[i >> 2] |= 0x80 << ((i % 4) << 3);
    if (i > 55) {
      md5cycle(state, tail);
      for (i = 0; i < 16; i++) tail[i] = 0;
    }
    tail[14] = n * 8;
    md5cycle(state, tail);
    return state.map((x) => {
      const hex = (x < 0 ? x + 0x100000000 : x).toString(16);
      return '00000000'.substring(hex.length) + hex;
    }).join('');
  }

  // Get product data from data-attributes
  const dataEl = document.getElementById('notify-me-data');
  const productOptions = dataEl ? JSON.parse(dataEl.dataset.productOptions || '[]') : [];
  const productTitle = dataEl ? JSON.parse(dataEl.dataset.productTitle || '""') : '';
  const variantSkuMapEl = document.getElementById('notify-me-variant-sku-map');
  let variantSkuMap = {};
  if (variantSkuMapEl) {
    try {
      variantSkuMap = JSON.parse(variantSkuMapEl.textContent || '{}');
    } catch (e) {
      console.error('Error parsing notify-me variant SKU map:', e);
    }
  }

  const form = document.getElementById('notify-me-form');
  const emailInput = document.getElementById('notify-me-email');
  const emailRequired = modal.querySelector('.notify-me-email-required');
  const emailError = modal.querySelector('.notify-me-email-error');
  const closeSuccessBtn = modal.querySelector('.notify-me-close-success');

  // Elements to update on variant change
  const productImageEl = modal.querySelector('[data-notify-image]');
  const lensTypeEl = modal.querySelector('[data-notify-lens-type]');
  const colorEl = modal.querySelector('[data-notify-color]');
  const powerEl = modal.querySelector('[data-notify-power]');
  const variantIdInput = modal.querySelector('[data-notify-variant-id]');
  const productIdInput = modal.querySelector('[data-notify-product-id]');
  const productSkuInput = modal.querySelector('[data-notify-product-sku]');

  // Set initial state
  modal.setAttribute('data-state', 'idle');

  // Get option positions
  let lensTypePos = -1;
  let colorPos = -1;
  let powerPos = -1;

  productOptions.forEach((option, index) => {
    const optionName = option.toLowerCase();
    if (optionName === 'lens type') lensTypePos = index;
    else if (optionName === 'color') colorPos = index;
    else if (optionName === 'power') powerPos = index;
  });

  function hideEmailErrors() {
    emailRequired.classList.add('tw-hidden');
    emailError.classList.add('tw-hidden');
  }

  function getSkuByVariantId(variantId) {
    if (!variantId) return '';
    const sku = variantSkuMap[String(variantId)];
    return typeof sku === 'string' ? sku : '';
  }

  function normalizeTrackedProductId(value) {
    return (value || '').toString().trim();
  }

  function hasTealiumProductSuffix(value) {
    return /\.(COM|RSF)$/i.test(normalizeTrackedProductId(value));
  }

  function getDefaultTrackedProductId() {
    const tealiumProducts = window.tealium?.products;
    if (!tealiumProducts || typeof tealiumProducts !== 'object') return '';

    const [productId] = Object.keys(tealiumProducts);
    return normalizeTrackedProductId(productId);
  }

  function resolveTrackedProductId(variantId, skuValue, fallbackProductId) {
    const candidates = [
      skuValue,
      getSkuByVariantId(variantId),
      fallbackProductId,
      getDefaultTrackedProductId(),
      variantId
    ]
      .map(normalizeTrackedProductId)
      .filter(Boolean);

    return candidates.find(hasTealiumProductSuffix) || candidates[0] || '';
  }

  // Function to get custom variant data
  function getCustomVariantsData() {
    const script = document.querySelector('#CustomVariantsScript');
    if (script) {
      try {
        const data = JSON.parse(script.textContent);
        return data;
      } catch (e) {
        console.error('Error parsing CustomVariantsScript:', e);
      }
    }
    return [];
  }

  // Function to get variant image from custom data or gallery script
  function getVariantImage(colorValue) {
    const customVariants = getCustomVariantsData();
    
    // Find variant with matching color that has images
    const matchingVariant = customVariants.find(v => 
      v.color === colorValue && v.meta_images && v.meta_images !== '#N/D'
    );
    
    if (matchingVariant && matchingVariant.meta_images) {
      // Get first image from meta_images
      const firstImage = matchingVariant.meta_images.split(',')[0].toLowerCase();
      if (firstImage) {
        // Find the actual image URL from script-gallery-images
        const scriptSlides = document.querySelectorAll('.script-gallery-images script');
        for (const script of scriptSlides) {
          const scriptImgSrc = script.getAttribute('data-img-src');
          // Use includes() because scriptImgSrc has format: files/RedBluff-Angle-DarkTort_uuid.jpg
          // and firstImage is just: RedBluff-Angle-DarkTort
          if (scriptImgSrc && scriptImgSrc.toLowerCase().includes(firstImage)) {
            // Parse the script content to get the image URL
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = script.innerHTML;
            const img = tempDiv.querySelector('img');
            if (img && img.src) {
              return img.src;
            }
          }
        }
      }
    }
    return null;
  }

  // Function to update card info and image from current selections
  function updateCardFromSelections() {
    // Get current values from fieldsets
    const lensTypeFieldset = document.querySelector('[data-variant-attribute="lens type"]');
    const colorFieldset = document.querySelector('[data-variant-attribute="color"]');
    const powerFieldset = document.querySelector('[data-variant-attribute="power"]');
    const selectedVariantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');

    let selectedColor = '';

    if (selectedVariantInput && variantIdInput) {
      variantIdInput.value = selectedVariantInput.value || '';
    }
    if (selectedVariantInput && productSkuInput) {
      productSkuInput.value = getSkuByVariantId(selectedVariantInput.value) || '';
    }
    if (selectedVariantInput && productIdInput) {
      productIdInput.value = resolveTrackedProductId(
        selectedVariantInput.value,
        productSkuInput ? productSkuInput.value : '',
        productIdInput.dataset.baseProductId
      );
    }

    // Update Lens Type
    if (lensTypeEl && lensTypeFieldset) {
      const selectedInput = lensTypeFieldset.querySelector('input:checked');
      const lensTypeValue = selectedInput?.value || '';
      if (lensTypeValue) {
        lensTypeEl.textContent = lensTypeValue;
        lensTypeEl.classList.remove('tw-hidden');
      } else {
        lensTypeEl.classList.add('tw-hidden');
      }
    }

    // Update Color
    if (colorFieldset) {
      const selectedInput = colorFieldset.querySelector('input:checked');
      selectedColor = selectedInput?.value || '';
      if (colorEl) {
        if (selectedColor) {
          colorEl.textContent = selectedColor;
          colorEl.classList.remove('tw-hidden');
        } else {
          colorEl.classList.add('tw-hidden');
        }
      }
    }

    // Update Power
    if (powerEl && powerFieldset) {
      const selectedInput = powerFieldset.querySelector('input:checked');
      const powerValue = selectedInput?.value || '';
      if (powerValue) {
        powerEl.textContent = powerValue;
        powerEl.classList.remove('tw-hidden');
      } else {
        powerEl.classList.add('tw-hidden');
      }
    }

    // Update Image based on selected color
    if (productImageEl && selectedColor) {
      const newImageUrl = getVariantImage(selectedColor);
      if (newImageUrl) {
        productImageEl.src = newImageUrl;
        productImageEl.alt = productTitle + ' - ' + selectedColor;
      }
    }
  }

  // Function to update card info from variant object (from pub/sub)
  function updateCardFromVariant(variant) {
    if (!variant) return;

    // Update variant ID in form
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }
    const resolvedSku = (variant.sku || getSkuByVariantId(variant.id) || '').toString();
    if (productSkuInput) {
      productSkuInput.value = resolvedSku;
    }
    if (productIdInput) {
      productIdInput.value = resolveTrackedProductId(
        variant.id,
        resolvedSku,
        productIdInput.dataset.baseProductId
      );
    }

    // Update Product Image
    if (productImageEl && variant.featured_image) {
      productImageEl.src = variant.featured_image.src;
      productImageEl.alt = variant.featured_image.alt || productTitle;
    }

    // Update Lens Type
    if (lensTypeEl) {
      const lensTypeValue = lensTypePos >= 0 ? variant.options[lensTypePos] : '';
      if (lensTypeValue) {
        lensTypeEl.textContent = lensTypeValue;
        lensTypeEl.classList.remove('tw-hidden');
      } else {
        lensTypeEl.classList.add('tw-hidden');
      }
    }

    // Update Color
    if (colorEl) {
      const colorValue = colorPos >= 0 ? variant.options[colorPos] : '';
      if (colorValue) {
        colorEl.textContent = colorValue;
        colorEl.classList.remove('tw-hidden');
      } else {
        colorEl.classList.add('tw-hidden');
      }
    }

    // Update Power
    if (powerEl) {
      const powerValue = powerPos >= 0 ? variant.options[powerPos] : '';
      if (powerValue) {
        powerEl.textContent = powerValue;
        powerEl.classList.remove('tw-hidden');
      } else {
        powerEl.classList.add('tw-hidden');
      }
    }
  }

  // Subscribe to variant change events (pub/sub)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (variant) {
        updateCardFromVariant(variant);
      }
    });
  }

  // Listen to color swatch clicks specifically
  document.addEventListener('click', (e) => {
    const colorInput = e.target.closest('[data-variant-attribute="color"] input[type="radio"]');
    if (colorInput) {
      // Wait for the swiper to update, then get the image
      setTimeout(() => {
        updateCardFromSelections();
      }, 300);
    }
  });

  // Listen to other variant changes
  document.addEventListener('change', (e) => {
    const fieldset = e.target.closest('[data-variant-attribute]');
    if (fieldset && e.target.type === 'radio') {
      setTimeout(() => {
        updateCardFromSelections();
      }, 100);
    }
  });

  function updateAnnouncementBarHeight() {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const announcementBar = document.querySelector('.announcement-bar') || document.querySelector('[class*="announcement"]');
    let height = 0;
    
    if (headerGroup) {
      height = headerGroup.offsetHeight;
    } else if (announcementBar) {
      height = announcementBar.offsetHeight;
    }
    
    modal.style.setProperty('--announcement-bar-height', height + 'px');
  }

  // Observe modal open/close
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'open') {
        if (modal.hasAttribute('open')) {
          updateAnnouncementBarHeight();
          document.body.classList.add('tw-overflow-hidden');
          // Reset state when opening
          modal.setAttribute('data-state', 'idle');
          form.reset();
          hideEmailErrors();
          updateCardFromSelections();
        } else {
          document.body.classList.remove('tw-overflow-hidden');
        }
      }
    });
  });
  
  observer.observe(modal, { attributes: true });

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.close();
    }
  });

  // Clean up body class on close
  modal.addEventListener('close', () => {
    document.body.classList.remove('tw-overflow-hidden');
  });

  // Close success button
  if (closeSuccessBtn) {
    closeSuccessBtn.addEventListener('click', () => {
      modal.close();
    });
  }

  // Email validation on input
  emailInput.addEventListener('input', () => {
    hideEmailErrors();
  });

  // Form submission
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    hideEmailErrors();

    // Check if empty
    if (!emailInput.value.trim()) {
      emailRequired.classList.remove('tw-hidden');
      emailInput.focus();
      return;
    }

    // Check if valid email format
    if (!emailInput.validity.valid) {
      emailError.classList.remove('tw-hidden');
      emailInput.focus();
      return;
    }

    modal.setAttribute('data-state', 'loading');

    const formData = new FormData(form);
    const data = {
      email: formData.get('email'),
      variant_id: formData.get('variant_id'),
      product_id: formData.get('product_id'),
      product_sku: formData.get('product_sku'),
      product_title: formData.get('product_title')
    };

    try {
      // TODO: Replace with your actual back-in-stock notification endpoint
      // This is a placeholder that simulates an API call
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          // Simulate success (change to reject() to test error state)
          resolve();
        }, 1500);
      });

      modal.setAttribute('data-state', 'success');

      // Tealium push: OOS email signup success (Events_ProdViewEcomOosEmailClick)
      const emailNormalized = (data.email || '').toString().trim().toLowerCase();
      const variantId = (data.variant_id || '').toString();
      if (emailNormalized && typeof tealium_data2track !== 'undefined' && typeof tealium_data2track.push === 'function') {
        const userEmailMd5 = md5Hex(emailNormalized);
        const userEmailSha256 = await sha256Hex(emailNormalized);
        const productIdKey = resolveTrackedProductId(
          variantId,
          (data.product_sku || '').toString(),
          (data.product_id || '').toString()
        );
        tealium_data2track.push({
          'id': 'Event',
          'Events_UserEmailSub': '0',
          'Events_ProdViewEcomOosEmailClick': '1',
          'User_Email_MD5': userEmailMd5,
          'User_Email_SHA256': userEmailSha256,
          'Products': productIdKey ? {
            [productIdKey]: {
              'Category': '',
              'FrameType': '',
              'LensType': ''
            }
          } : {}
        });
      }
    } catch (error) {
      console.error('Notify me error:', error);
      modal.setAttribute('data-state', 'error');
    }
  });
})();
